import React, { useEffect, useRef, useState } from "react";
import { Line, Bar, Pie } from "react-chartjs-2";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import LineChart from "../DashBoard/LineChart";
import { CloudDownloadOutlined, DownloadOutlined } from "@ant-design/icons";
import moment from "moment/moment";
import config from "../../config/config";
import Select from "react-select";
import BarLineLineChart from "../DashBoard/BarLineLineChart";
import supervisionService from "../../services/supervision-service"
import dashboardService from "../../services/dashboard-phenological-service"
import MultiLineChart from "../DashBoard/MultiLineChart";


// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardPhenological = () => {


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);


  
  const [listCutBunches, setListCutBunches] = useState([]);
  const [listCollectedBunches, setListCollectedBunches] = useState([]);
  const [cutBunches, setCutBunches] = useState(0);
  const [collectedBunches, setCollectedBunches] = useState(0);





  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)
  const [listLineData, setListLineData] = useState([]);
  const [hectaresData, setHectaresData] = useState([]);

  const [loading, setLoading] = useState(false);

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");

 
  
    const [dataApplications, setDataApplications] = useState([])

  const [totalHectares, setTotalHectares] = useState(0);
  const [totalPalms, setTotalPalms] = useState(0);
  const [bunchesByPalm, setBunchesByPalm] = useState(0);
  const [ApplicationByHectare, setApplicationByHectare] = useState(0);

  const [valuesLotX, setValuesLotX] = useState([])
  const [valuesLotY, setValuesLotY] = useState([])

  registerLocale("es", es);
  const start_date_supervision = moment().add(-config.DAYS_LESS_SUPERVISION, 'd').startOf("day").toDate();
  const start_date = moment().add(-config.DAYS_LESS, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);

  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");




  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////




  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };


  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }



  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };








  ///RACIMOS POR DIA
  const getApplicationsByDay = async () => {
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setListLineData([])
    const userId = getValues("userId")
    const params = {startDate:start, endDate:end,farmId,lotId,sectionId,lots:selectedLotes,userId}
    const result = await dashboardService.applicationsByDay(params);
    let countCollectedBunches = 0
    let countCutBunches = 0



    let data_607 = []
    let data_609 = []
    let data_703 = []


    if (result) {
      result.map((item) => {
        const fecha = formatDate(item._id);
        const total_607 = item.total_607;
        const total_609 = item.total_609;
        const total_703 = item.total_703;

        data_607.push({ day: fecha, value: total_607 });
        data_609.push({ day: fecha, value: total_609 });
        data_703.push({ day: fecha, value: total_703 })
      });
    }    
   
    let data =[
        {
            "name": "607",
            "data": data_607
        },
        {
            "name": "609",
            "data": data_609
        },
        {
            "name": "703",
            "data": data_703
        }
    ]
    setDataApplications(data)
  };





  const loadDashBoard = () => {
    getApplicationsByDay();
  };



  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();





  const cardStyle = {
    padding: "18px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };



  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };






  const getListFilterUsers = async () => {
    const farmId = getValues("farm")
    const lotId = getValues("lot")
    const userId = "0"
    setValue("userId", "0")
    try {
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListFilterUsers();
  }, [startDate, endDate, farmId, sectionId, lotId]);




  useEffect(() => {
    getLisFarm();
    getListFilterUsers()
    loadDashBoard()

    setTimeout(() => {
      chartOneRef.current?.getEchartsInstance().resize();
      chartTwoRef.current?.getEchartsInstance().resize();
      chartThreeRef.current?.getEchartsInstance().resize();
    }, 150);






  }, []);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "18px",
      }}
    >

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Dashboard estado fenológico</Divider>
      </div>


      <div className="row">
        <div className="col-12">
          <form className="form-react">
            <div className="row mb-3">

              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>







              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>





              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>

              <div className=" col-12 col-sm-4 ">
                <label className="text-secondary fw-bold">Usuario</label>
                <select
                  className="form-control text-secondary"
                  {...register("userId")}
                >
                  {listUsers.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className="mt-2 col-12 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Expandir graficas</label>
                </div>
              </div>

              <div className="mt-2 col-2 d-none"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeStateShowValues(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Ocultar valores</label>
                </div>
              </div>


            </div>



          </form>
        </div>



        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#3F51B5" }}>Racimos cortados: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{cutBunches.toLocaleString()}</label>
          </div>
        </div>


        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#3F51B5" }}>Racimos recogidos: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{collectedBunches.toLocaleString()}</label>
          </div>
        </div>






        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Palmas: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{totalPalms.toLocaleString()}</label>
          </div>
        </div>




        <div className="col-12 col-sm-3 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "18px", fontWeight: "bold", color: "#00D9A3" }}>Racimos/palma: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "18px", fontWeight: "bold" }}>{bunchesByPalm.toLocaleString()}</label>
          </div>
        </div>





       


  <div className={expandChats ? "col-12 mt-2" : "col-12 col-sm-12 mt-4"}>
          <div style={cardStyle}>
            <MultiLineChart
              chartRef={chartThreeRef}
              title="Aplicaciones por fenología"
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle=""
              yLabel="Racimos"
              showSerieValue={showLineValues}
              decimals={0}
              data={dataApplications}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartThreeRef, "ciclos-polinizacion.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>












      </div>
    </div>
  );
};

export default DashboardPhenological;